import axios from 'axios';
import { Agent } from 'https';
const https = require('https');
// import { restfulApiConfig } from '../../../config';

/** ヘッダー設定 */
const defaultHeaders = (url) => {
	if(url === 'production') {
		axios.defaults.headers['X-Requested-With'] 	= 'XMLHttpRequest';
		axios.defaults.headers['Content-Type'] 		= 'application/json';
	}
	else if(url === 'development') {
		axios.defaults.headers['Content-Type'] 		= 'application/json';
	}
	else if(url === 'ut') {
		axios.defaults.headers['X-Requested-With'] 	= 'XMLHttpRequest';
		axios.defaults.headers['Content-Type'] 		= 'application/json';
	}
	else if(url === 'sit') {
		axios.defaults.headers['X-Requested-With'] 	= 'XMLHttpRequest';
		axios.defaults.headers['Content-Type'] 		= 'application/json';
	}
	else if(url === 'uat') {
		axios.defaults.headers['X-Requested-With'] 	= 'XMLHttpRequest';
		axios.defaults.headers['Content-Type'] 		= 'application/json';
	}
	else if(url === 'pre') {
		axios.defaults.headers['X-Requested-With'] 	= 'XMLHttpRequest';
		axios.defaults.headers['Content-Type'] 		= 'application/json';
	}
	return axios.defaults.headers;
};

const apiHeaders = (url) => {
	axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
};

/**
 * サーバー用
 */
export const i_axios = axios.create({
	baseURL: process.env.API_URL,
	headers: defaultHeaders(process.env.NODE_ENV),
	responseType: 'json',
	timeout: 180000,
	xsrfHeaderName: '_csrf',
	xsrfCookieName: '_ctkn',
	// httpsAgent: new Agent({
	// 	rejectUnauthorized: false
	// }),
	withCredentials: true
});

/**
 * 住所検索用
 */
export const t_axios = axios.create({
	baseURL: process.env.API_ADDRESS_URL,
	headers:  {
		'Content-Type': 'application/x-www-form-urlencoded',
	},
	responseType: 'json',
	timeout: 5000
});

/**
 * MDKトークン発行用
 */
export const c_axios = axios.create({
	// baseURL: 'http://localhost:8888/mock/payment',
	// baseURL: process.env.API_MDK_URL,
	baseURL: 'https://api3.veritrans.co.jp',
	headers: {
		'Accept': 'application/json',
		'Content-Type': 'application/json'
	},
	timeout: 60000,
	responseType: 'json',
	httpsAgent: new Agent({
		rejectUnauthorized: false
	})
});

export const g_axios = axios.create({
	headers: {
		'Accept': 'application/xml',
		'Content-Type': 'application/xml'
	},
	responseType: 'text',
	httpsAgent: new Agent({
		rejectUnauthorized: false
	})
});

// console.log('環境：' + process.env.NODE_ENV + ' config：　' + restfulApiConfig.apiKey);
